import { useTranslation } from 'react-i18next';

export const keyPrefix = 'edit_user';
export const useEditUserTranslation = () => useTranslation('features', { keyPrefix });

export const ruRu = ({
  [keyPrefix]: {
    button: 'Изменить',
    toast_success: 'Данные пользователя успешно изменены',
    toast_error: 'Не удалось изменить данные пользователя',
  },
}) as Record<string, unknown>;

export const en = ({
  [keyPrefix]: {
    button: 'Edit',
    toast_success: 'User data successfully updated',
    toast_error: 'Failed to update user data',
  },
}) as Record<string, unknown>;

export const ptBr = ({
  [keyPrefix]: {
    button: 'Editar',
    toast_success: 'Dados do usuário alterados com sucesso',
    toast_error: 'Falha ao alterar os dados do usuário',
  },
}) as Record<string, unknown>;

export const esEs = ({
  [keyPrefix]: {
    button: 'Editar',
    toast_success: 'Datos del usuario modificados correctamente',
    toast_error: 'Error al modificar los datos del usuario',
  },
}) as Record<string, unknown>;
